// Pricing Block JS
document.addEventListener('DOMContentLoaded', () => {
  // Currently no JS functionality is needed
  // This file is created for consistency with other blocks
}); 